/* eslint-disable no-console */
import toast from "react-hot-toast";
import { client } from ".";

export const updateUsuario = async ({
  id,
  email,
  agencia,
  cliente_id,
  cargo,
  cargo_detalle,
  nombre,
  apellido,
  rol,
  telefono,
  fecha_nacimiento,
}) => {
  try {
    const updates = {
      email: email?.trim() || null,
      ...(agencia !== undefined && { agencia: agencia === "" ? null : parseInt(agencia, 10) }),
      ...(cliente_id !== undefined && { cliente_id: cliente_id === "" ? null : parseInt(cliente_id, 10) }),
      ...(cargo !== undefined && { cargo: cargo || null }),
      ...(cargo_detalle !== undefined && { cargo_detalle: cargo_detalle || null }),
      ...(nombre !== undefined && { nombre }),
      ...(apellido !== undefined && { apellido }),
      ...(rol !== undefined && { rol }),
      ...(telefono !== undefined && { telefono: telefono || null }),
      ...(fecha_nacimiento !== undefined && { fecha_nacimiento: fecha_nacimiento || null }),
    };

    const { data, error } = await client.from("usuarios").update(updates).eq("id", id).select(); // sin .single()

    if (error) throw error;
    if (!data || data.length === 0) throw new Error("No se actualizó ninguna fila");

    return data[0]; // devuelve la fila actualizada
  } catch (error) {
    console.error("Error en updateUsuario:", error);
    toast.error("Error al actualizar usuario");
    throw error;
  }
};
